// tcms-frontend/src/pages/DiagnosticsCentre.js
//
// Minimal page: one button that opens the Diagnostics app's centre page
// with a short-lived token that DOES NOT include user_key.
//
// Env:
//   REACT_APP_DIAGNOSTICS_APP_URL        e.g. https://diagnostics.staging.mygooroo.io
//   REACT_APP_DIAGNOSTICS_CENTRE_PATH    default: /diagnostics/centre
//
import React, { useState } from "react";
import Button from "@mui/material/Button";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import { NavLink } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { security_key, BASE_URL } from "../global";

const DIAG_APP = (process.env.REACT_APP_DIAGNOSTICS_APP_URL || "http://localhost:5173").replace(/\/+$/, "");
const CENTRE_PATH = process.env.REACT_APP_DIAGNOSTICS_CENTRE_PATH || "/diagnostics/centre";

export default function DiagnosticsCentre() {
    const [busy, setBusy] = useState(false);

    const openCentre = async () => {
        const fk = sessionStorage.getItem("key");
        if (!fk) {
            toast.error("Missing centre key in sessionStorage.");
            return;
        }
        setBusy(true);
        try {
            const res = await axios.post(BASE_URL + "API/api_index.php", {
                security_key,
                mode: "diagnostics_generate_token",
                fk_tenat_key: fk,
                // NOTE: no user_key on purpose
                purpose: "centre",
            });

            const ok = !!res?.data?.success;
            const token = res?.data?.token ?? res?.data?.data?.token;

            if (ok && token) {
                const url = `${DIAG_APP}${CENTRE_PATH}?token=${encodeURIComponent(token)}`;
                // Same-tab navigation avoids popup blockers and flicker
                window.location.assign(url);
            } else {
                toast.error(res?.data?.message || res?.data?.error || "Could not initialize token.");
            }
        } catch (e) {
            console.error(e);
            toast.error("Could not initialize token.");
        } finally {
            setBusy(false);
        }
    };

    return (
        <>
            <ToastContainer position="top-center" />
            <div className="page-wrapper">
                <div className="mb-3 d-flex justify-content-between align-items-center">
                    <div>
                        <h5 className="page-title">Diagnostics Centre</h5>
                        <div role="presentation">
                            <Breadcrumbs aria-label="breadcrumb" className="my-breadcrumbs">
                                <NavLink underline="hover" color="inherit" to="/calendar">Home</NavLink>
                                <Typography color="text.primary">Diagnostics Centre</Typography>
                            </Breadcrumbs>
                        </div>
                    </div>
                </div>

                <div className="my-card p-4 bg-white">
                    <p className="mb-3">Open the Diagnostics app centre page for this tenant.</p>
                    <Button
                        variant="contained"
                        className="primary-filled"
                        onClick={openCentre}
                        disabled={busy}
                    >
                        {busy ? "Opening..." : "Open Diagnostics Centre"}
                    </Button>
                </div>
            </div>
        </>
    );
}
